/* 321 Cookie - plain Add to cart for non-designer products
   Theme ASSET, loaded from the product Custom Liquid block with:
       <script src="{{ 'cookie-buy.js' | asset_url }}" defer></script>

   Split out of the Liquid block on 2026-08-25. It used to be an inline <script>
   in the block's else branch, which meant the ready-made branch (which needs the
   SAME behaviour, plus the designer popup) would have had to duplicate it. One
   implementation, loaded by both branches; it no-ops when .cd-buy is absent.

   Handles two of the three product types:
     * READY-MADE design (data-design-id present)  -> adds WITH the stored design
       as _design_id / _design_url / Design line-item properties, because the
       poller (cookie_poller.expand_jobs) only fulfils lines carrying _design_id.
     * PHYSICAL PRESS / anything else (no design id) -> adds with no properties.

   Single-variant assumption, same as before: if a non-designer product ever gets
   multiple variants this needs a variant picker.

   Contains NO Liquid - keep it that way or it cannot live in /assets.
*/
(function () {
  'use strict';

  var root = document.querySelector('.cd-buy');
  if (!root) return;

  var btn = root.querySelector('.cd-buy-btn');
  var qtyEl = root.querySelector('.cd-buy-qty');
  var statEl = root.querySelector('.cd-buy-status');
  if (!btn) return;

  var did = root.getAttribute('data-design-id') || '';
  var durl = root.getAttribute('data-design-url') || '';
  var title = root.getAttribute('data-design-title') || '';

  function say(msg, kind) {
    if (!statEl) return;
    statEl.textContent = msg || '';
    statEl.className = 'cd-buy-status' + (kind ? ' ' + kind : '');
  }

  function variantId() {
    // Prefer a live variant input if the theme rendered one, else the value
    // Liquid injected.
    var sel = document.querySelector('form[action*="/cart/add"] [name="id"], [name="id"]');
    if (sel && sel.value) return sel.value;
    return root.getAttribute('data-variant') || '';
  }

  // Tell Horizon the cart changed. Its header icon (assets/cart-icon.js) listens
  // for 'cart:update' on document and takes the new count from
  // detail.data.itemCount - the same event its own product form fires. A source
  // other than 'product-form-component' makes it SET the count rather than add
  // to it, so the number is always the cart's real total. This store uses the
  // cart PAGE (cart_type: page), so no drawer opens.
  function announceCart(cart, source) {
    try {
      if (!cart || typeof cart.item_count !== 'number') return;
      var ev;
      try { ev = new Event('cart:update', { bubbles: true }); }
      catch (e) { ev = document.createEvent('Event'); ev.initEvent('cart:update', true, false); }
      ev.detail = { resource: cart, sourceId: source,
                    data: { source: source, itemCount: cart.item_count } };
      document.dispatchEvent(ev);
    } catch (e) {}
  }

  btn.addEventListener('click', function () {
    var vid = variantId();
    if (!vid) { say('Sorry — could not find this product’s variant.', 'error'); return; }
    var qty = Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1);
    var item = { id: vid, quantity: qty };
    if (did) {
      item.properties = { '_design_id': did, '_design_url': durl, 'Design': title || durl };
    }
    btn.disabled = true;
    say('Adding to cart…');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [item] })
    })
    .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, status: r.status, body: j }; }); })
    .then(function (res) {
      if (!res.ok) {
        say((res.body && (res.body.description || res.body.message)) ||
            ('Could not add to cart (' + res.status + ').'), 'error');
        btn.disabled = false;
        return;
      }
      // VERIFY it actually landed - add.js can return 200 yet not persist.
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          btn.disabled = false;
          if (cart && cart.item_count > 0) {
            announceCart(cart, 'cd-buy');
            say('✓ Added! ' + cart.item_count + ' item' +
                (cart.item_count > 1 ? 's' : '') + ' in your cart.', 'ok');
          } else {
            say('The item did not stay in the cart — it may not be purchasable ' +
                '(check inventory/price).', 'error');
          }
        });
    })
    .catch(function () {
      btn.disabled = false;
      say('Network error adding to cart. Please try again.', 'error');
    });
  });
})();


/* ===========================================================================
   DESIGN PROPERTY GUARD  (added 2026-08-27)

   Why this exists
   ---------------
   The .cd-buy button above attaches _design_id / _design_url / Design, because
   the poller fulfils a line by those properties. But .cd-buy is no longer the
   ONLY add-to-cart on a ready-made product page: templates/product.json has
   "enable_sticky_add_to_cart": true (Horizon's own sticky buy bar) and a
   buy-buttons block. Anything that posts the theme's product form adds the item
   with NO properties.

   That is what happened to order #1073 on 2026-08-27: twelve ready-made stamps,
   paid, every line without a _design_id. The poller skipped the whole order and
   it produced nothing until a server-side fallback was added.

   This guard makes every add-to-cart path on a ready-made product page carry
   the design, whichever button the customer pressed:
     1. hidden properties[...] inputs stamped into every /cart/add form, so a
        theme-serialized submit carries them naturally, and
     2. a fetch() wrapper that fills them into a payload built by script.

   Scope, honestly stated:
     * It only runs on a page that rendered .cd-buy WITH a design id - so the
       designer product and the physical press are untouched (their data-design-id
       is empty).
     * It CANNOT fix quick-add from a collection or search page: those cards carry
       no design data at all. That is why the real fix is server-side -
       cookie_poller.expand_jobs() resolves the design from the product's
       cookie.design_id metafield. This guard is for admin visibility, not
       fulfilment.
     * Never overwrites a property that is already set, so .cd-buy's own request
       passes through untouched.

   Contains NO Liquid - keep it that way or it cannot live in /assets.
   =========================================================================== */
(function () {
  'use strict';

  var src = document.querySelector('.cd-buy[data-design-id]');
  var did = src && src.getAttribute('data-design-id');
  if (!did) return;                     // designer product, press, or no block

  var durl = src.getAttribute('data-design-url') || '';
  var title = src.getAttribute('data-design-title') || '';
  var PROPS = { '_design_id': did, '_design_url': durl, 'Design': title || durl };
  var KEYS = Object.keys(PROPS);
  var CART_ADD = /\/cart\/add(\.js)?(\?|$)/;

  // --- 1. hidden inputs on every product form -------------------------------
  function stamp(form) {
    if (!form || form.__cdStamped) return;
    form.__cdStamped = true;
    KEYS.forEach(function (k) {
      var name = 'properties[' + k + ']';
      if (form.querySelector('[name="' + name + '"]')) return;   // already there
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = PROPS[k];
      form.appendChild(input);
    });
  }

  function stampAll() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) stamp(forms[i]);
  }

  stampAll();
  // The sticky bar and any drawer render late, so keep watching.
  if (window.MutationObserver) {
    new MutationObserver(stampAll).observe(document.documentElement,
                                           { childList: true, subtree: true });
  }

  // --- 2. fetch wrapper, for scripts that build their own payload -----------
  function fillObject(obj) {
    if (!obj || typeof obj !== 'object') return obj;
    if (Array.isArray(obj.items)) {
      obj.items.forEach(fillObject);
      return obj;
    }
    obj.properties = obj.properties || {};
    KEYS.forEach(function (k) {
      if (obj.properties[k] === undefined || obj.properties[k] === '') {
        obj.properties[k] = PROPS[k];
      }
    });
    return obj;
  }

  function fillPairs(pairs) {          // FormData or URLSearchParams
    KEYS.forEach(function (k) {
      var name = 'properties[' + k + ']';
      if (!pairs.get(name)) pairs.append(name, PROPS[k]);
    });
    return pairs;
  }

  var nativeFetch = window.fetch;
  if (typeof nativeFetch !== 'function') return;

  window.fetch = function (input, init) {
    try {
      var url = (typeof input === 'string') ? input
              : (input && input.url) ? input.url : '';
      // A Request object carries its body in a stream we cannot rewrite
      // synchronously; the hidden inputs above still cover that path.
      if (CART_ADD.test(url) && typeof input === 'string' && init && init.body) {
        var b = init.body;
        if (typeof FormData !== 'undefined' && b instanceof FormData) {
          fillPairs(b);
        } else if (typeof URLSearchParams !== 'undefined' && b instanceof URLSearchParams) {
          fillPairs(b);
        } else if (typeof b === 'string') {
          var t = b.trim();
          if (t.charAt(0) === '{') {
            init.body = JSON.stringify(fillObject(JSON.parse(b)));
          } else if (t.indexOf('=') > -1) {
            init.body = fillPairs(new URLSearchParams(b)).toString();
          }
        }
      }
    } catch (e) {
      /* never let this break a checkout - fall through to the original call */
    }
    return nativeFetch.apply(this, arguments);
  };
})();
